import { isWebview as _isWebview } from "./isWebview";

export { createWebviewHistoryWrapper } from "./createWebviewHistoryWrapper";
export { mobile } from "./mobile";
export {
  getInitialBtMobileContext,
  initializeMockBtMobileContext,
  useBtMobileContext,
} from "./mobileContext";

/** @deprecated Use {@link mobile}.isWebview instead for better type safety. */
export const isWebview = _isWebview;
export {
  emitWebviewNavigationEvent,
  handleWebviewBack,
} from "./webviewNavigationBridge";
export { notifyMobileEntityChanged } from "./mobileEntityChanged";
export {
  resolveAttachmentCorrelation,
  abandonAttachmentCorrelation,
} from "./attachmentCorrelation";
export {
  installRNEventBridge,
  subscribeRNEvent,
  type RNEventHandler,
} from "./rnEventBridge";
export { useRNEvent } from "./useRNEvent";
export { useMobileBackHandler } from "./useMobileBackHandler";
export { useHideNativeTabBar } from "./useHideNativeTabBar";
export {
  registerBackHandler,
  type BackHandler,
} from "./mobileBackHandlerRegistry";
export {
  WebviewContextProvider,
  useWebviewContext,
  type WebviewRouteType,
  type IWebviewContextState,
  type IWebviewContextResult,
  type IWebviewContextProviderProps,
} from "./WebviewContext";
export type { IWebviewRouteParams, MobileWebview } from "./types";
export type {
  CompressAndUploadOptions,
  CompressAndUploadResult,
  DownloadFileEventPayload,
  FilePickerAttachmentsOptions,
  FilePickerAttachmentsResult,
  FilePickerStandaloneOptions,
  FilePickerStandaloneResult,
  FilePickerToggleOption,
  Jobsite,
  JobsitesPickerScreenProps,
  MobileBackHandlerStatePayload,
  MobileEntityType,
  MobileFunctions,
  MobileToWebEventKey,
  NavigationEventPayload,
  PickedAttachmentFile,
  PickedAttachmentFileBase,
  PickedTempFile,
  PickedVideo,
  PortalType,
  ShareEventPayload,
  WebviewBridgeApi,
} from "@bt-mobile/shared-contracts";
export { JobStatus } from "@bt-mobile/shared-contracts";
